export const fontFamilyTokens = [
  {
    name: 'Primary Font',
    value: 'var(--font-family-sans, Montserrat, sans-serif)',
  },
];

export const fontSizeTokens = [
  { name: 'Extra Small', value: 'var(--font-size-xs, 0.75rem)' },
  { name: 'Small', value: 'var(--font-size-sm, 0.875rem)' },
  { name: 'Base', value: 'var(--font-size-base, 1rem)' },
  { name: 'Large', value: 'var(--font-size-lg, 1.125rem)' },
  { name: 'Extra Large', value: 'var(--font-size-xl, 1.25rem)' },
  { name: '2XL', value: 'var(--font-size-2xl, 1.5rem)' },
  { name: '3XL', value: 'var(--font-size-3xl, 1.875rem)' },
  { name: '4XL', value: 'var(--font-size-4xl, 2.25rem)' },
  { name: '5XL', value: 'var(--font-size-5xl, 3rem)' },
  { name: '6XL', value: 'var(--font-size-6xl, 3.75rem)' },
  { name: '7XL', value: 'var(--font-size-7xl, 4.5rem)' },
  { name: '8XL', value: 'var(--font-size-8xl, 6rem)' },
  { name: '9XL', value: 'var(--font-size-9xl, 8rem)' },
];

export const lineHeightTokens = [
  { name: 'None', value: 'var(--line-height-none, 1)' },
  { name: 'Tight', value: 'var(--line-height-tight, 1.1)' },
  { name: 'Snug', value: 'var(--line-height-snug, 1.2)' },
  { name: 'Normal', value: 'var(--line-height-normal, 1.4)' },
  { name: 'Relaxed', value: 'var(--line-height-relaxed, 1.5)' },
  { name: 'Loose', value: 'var(--line-height-loose, 1.6)' },
  { name: 'Extra Loose', value: 'var(--line-height-extraloose, 1.8)' },
  { name: '2XL', value: 'var(--line-height-2xloose, 2)' },
];

export const letterSpacingTokens = [
  { name: 'Tighter', value: 'var(--tracking-tighter)' },
  { name: 'Tight', value: 'var(--tracking-tight)' },
  { name: 'Normal', value: '0em' },
  { name: 'Wide', value: 'var(--tracking-wide)' },
  { name: 'Wider', value: 'var(--tracking-wider)' },
  { name: 'Widest', value: 'var(--tracking-widest)' },
];

export const fontWeightTokens = [
  { name: 'Thin', value: '100' },
  { name: 'Extra Light', value: '200' },
  { name: 'Light', value: '300' },
  { name: 'Normal', value: '400' },
  { name: 'Medium', value: '500' },
  { name: 'Semi Bold', value: '600' },
  { name: 'Bold', value: '700' },
  { name: 'Extra Bold', value: '800' },
  { name: 'Black', value: '900' },
];
